import script from "./CreateBatch.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateBatch.vue?vue&type=script&setup=true&lang=ts"

import "./CreateBatch.vue?vue&type=style&index=0&id=bd71a446&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd71a446"]])

export default __exports__